import React from "react";
import aboutUsImage from "../images/about-us.png";
import "../styles/AboutUs.css";

export default function AboutUs() {
  return (
    <div className="p-3 main" id="about-us">
      <section className="row p-0 m-0">
        <section className="col-lg-6 col-sm-12 col-md-12 p-2">
          <h3>About GirlScript Mumbai.</h3>
          <br />
          <span className="contentText">
            GirlScript Mumbai is a non-profit tech community under GirlScript
            India for Students, Software Developers, IT Professionals, and
            Entrepreneurs. The organizing team consists of energized individuals
            from several colleges in Mumbai. We believe in being the force that
            transforms how students learn in India. We encourage our members to
            become the 'students they would want to teach'. GirlScript focuses
            on beginners and learners. At GirlScript, we try to entertain
            members from all domains irrespective of their experience, gender,
            and age through conducting workshops and technical programs. Our aim
            is to provide everyone with a platform to exchange great ideas and
            knowledge.
          </span>
          <br />
          <br />
        </section>
        <section
          className="text-center col-lg-6 col-sm-12 col-md-12 p-0"
          style={{ padding: 0 }}
        >
          <img
            className="img-responsive"
            width="100%"
            src={aboutUsImage}
            alt="About Us"
          />
          <br />
          <br />
        </section>
      </section>
    </div>
  );
}
